import { render } from "./NavSidebar.vue?vue&type=template&id=c753cf06&ts=true"
import script from "./NavSidebar.vue?vue&type=script&lang=ts"
export * from "./NavSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__